"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import styles from "../../../styles/home/navbar/navbar.module.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 100);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isScrolled && <div style={{ height: '100px', width: '100%' }} aria-hidden="true" />}
      <header className={`${styles.navbar} ${isScrolled ? styles.sticky : ""} ${pathname === "/" && !isScrolled ? styles.homeNavbar : ""}`}>
      <Link href="/" prefetch={false} className={styles.logoContainer}>
        <Image 
          src="/home-page/logo/diagnomed-logo.webp" 
          alt="Diagnomed Logo" 
          width={240} 
          height={78} 
          priority
          fetchPriority="high"
          className={styles.logoImage}
        />
      </Link>
      
      <button 
        className={styles.menuToggle} 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Navigation"
      >
        <span className={`${styles.bar} ${isOpen ? styles.open : ""}`}></span>
        <span className={`${styles.bar} ${isOpen ? styles.open : ""}`}></span>
        <span className={`${styles.bar} ${isOpen ? styles.open : ""}`}></span>
      </button>

      <nav className={`${styles.navLinks} ${isOpen ? styles.active : ""}`}>
        <Link href="/" prefetch={false} className={styles.navLink} onClick={() => setIsOpen(false)}>Home</Link>
        <Link href="/about" prefetch={false} className={styles.navLink} onClick={() => setIsOpen(false)}>About</Link>
        
        <div className={styles.dropdownContainer}>
          <span className={styles.navLink} style={{ cursor: 'pointer' }}>Products</span>
          <div className={styles.dropdownMenu}>
            <Link href="/product/molecular-diagnostics" prefetch={false} className={styles.dropdownItem} onClick={() => setIsOpen(false)}>
              Molecular Diagnostics
            </Link>
            <Link href="/product/nucleic-acid-extraction" prefetch={false} className={styles.dropdownItem} onClick={() => setIsOpen(false)}>
              Nucleic Acid Extraction
            </Link>
          </div>
        </div>

        <div className={styles.dropdownContainer}>
          <span className={styles.navLink} style={{ cursor: 'pointer' }}>Suppliers</span>
          <div className={styles.dropdownMenu}>
            <Link href="/suppliers/anchor-diagnostics" prefetch={false} className={styles.dropdownItem} onClick={() => setIsOpen(false)}>
              ANCHOR Diagnostics
            </Link>
          </div>
        </div>
        <Link href="/news" prefetch={false} className={styles.navLink} onClick={() => setIsOpen(false)}>News & Events</Link>
        <Link href="/contact" prefetch={false} className={styles.navLink} onClick={() => setIsOpen(false)}>Contact</Link>
      </nav>
    </header>
    </>
  );
}
